// Palladium.Pwa — installability (online only).
// Reads its configuration from the <link rel="manifest"> rendered by PwaHead.razor,
// registers the no-op service worker and reveals the install buttons placed in
// the page (PwaInstallButton widget) — or the floating chip from the settings —
// when the browser fires beforeinstallprompt. iPhone / iPad never fire it, so
// there the buttons show at once and display the « Share → Add to Home Screen »
// steps on tap. Nothing here touches the Blazor circuit.
//
// This script runs before Blazor renders the page (InteractiveServer, no
// prerender), so buttons are looked up lazily and a MutationObserver catches
// the ones rendered later. window.PalladiumPwa exposes state + refresh().
(function () {
    'use strict';

    var link = document.querySelector('link[rel="manifest"][data-pd-pwa-sw]');
    if (!link) return;
    if (/^\/admin(\/|$)/i.test(location.pathname)) return;

    var swUrl = link.getAttribute('data-pd-pwa-sw');
    var scope = link.getAttribute('data-pd-pwa-scope') || '/';
    var wantChip = link.getAttribute('data-pd-pwa-install') === '1';
    var label = link.getAttribute('data-pd-pwa-label') || 'Installer l’application';
    var iosHint = link.getAttribute('data-pd-pwa-ios-hint') || '';
    var DISMISS_KEY = 'pd-pwa-dismissed';
    var DISMISS_DAYS = 30;
    var SELECTOR = '[data-pd-pwa-install-button]';

    // 1. Service worker (required by Chromium for the install prompt; does nothing else).
    if ('serviceWorker' in navigator && swUrl) {
        window.addEventListener('load', function () {
            navigator.serviceWorker.register(swUrl, { scope: scope }).catch(function (e) {
                console.warn('[pwa] service worker registration failed', e);
            });
        });
    }

    var standalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches
        || window.navigator.standalone === true;
    var isIos = /iPad|iPhone|iPod/.test(navigator.userAgent)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    var state = window.PalladiumPwa = { standalone: standalone, ios: isIos, installable: false, buttons: 0, refresh: refresh };
    if (standalone) return; // already running as an app: nothing to offer

    function dismissed() {
        try {
            var t = Number(localStorage.getItem(DISMISS_KEY) || 0);
            return t && (Date.now() - t) < DISMISS_DAYS * 86400000;
        } catch (e) { return false; }
    }
    function remember() { try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) { } }
    function buttons() { return Array.prototype.slice.call(document.querySelectorAll(SELECTOR)); }

    var deferred = null;   // the beforeinstallprompt event, kept until the user clicks
    var chip = null;       // floating chip element (settings option)
    var hintBox = null;    // iOS steps shown under the chip

    function install() {
        if (!deferred) return;
        var p = deferred;
        deferred = null;
        state.installable = false;
        p.prompt();
        p.userChoice.then(function (choice) {
            if (choice && choice.outcome === 'dismissed') remember();
            hide();
        }).catch(hide);
    }

    // iPhone / iPad: no install prompt exists — the button shows the Safari steps.
    function bindIos(btn) {
        var hint = btn.getAttribute('data-pd-pwa-ios-hint');
        if (!hint) return;
        btn.removeAttribute('hidden');
        if (btn._pdPwaBound) return;
        btn._pdPwaBound = true;
        btn.addEventListener('click', function () {
            var next = btn.nextElementSibling;
            if (next && next.classList.contains('pd-pwa-ioshint')) { next.remove(); return; }
            var span = document.createElement('span');
            span.className = 'pd-pwa-ioshint';
            span.setAttribute('role', 'status');
            span.textContent = hint;
            btn.insertAdjacentElement('afterend', span);
        });
    }

    function bindInstall(btn) {
        btn.removeAttribute('hidden');
        if (btn._pdPwaBound) return;
        btn._pdPwaBound = true;
        btn.addEventListener('click', install);
    }

    // iPhone / iPad: the chip cannot prompt, so it toggles the steps from the settings.
    function toggleHint() {
        if (hintBox) { hintBox.remove(); hintBox = null; return; }
        hintBox = document.createElement('div');
        hintBox.className = 'pd-pwa-install-hint';
        hintBox.setAttribute('role', 'status');
        hintBox.textContent = iosHint;
        document.body.appendChild(hintBox);
    }

    function showChip() {
        if (chip || !wantChip || dismissed()) return;
        chip = document.createElement('div');
        chip.className = 'pd-pwa-install';
        chip.setAttribute('role', 'dialog');
        chip.setAttribute('aria-label', label);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pd-pwa-install-btn';
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M7 10l5 5 5-5"/><path d="M12 15V3"/></svg>';
        btn.appendChild(document.createTextNode(label));
        btn.addEventListener('click', isIos ? toggleHint : install);

        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'pd-pwa-install-close';
        close.setAttribute('aria-label', 'Fermer');
        close.textContent = '×';
        close.addEventListener('click', function () { remember(); hideChip(); });

        chip.appendChild(btn);
        chip.appendChild(close);
        document.body.appendChild(chip);
    }
    function hideChip() {
        if (chip) { chip.remove(); chip = null; }
        if (hintBox) { hintBox.remove(); hintBox = null; }
    }

    // Sync the DOM with the current state. Safe to call any time (idempotent).
    function refresh() {
        var list = buttons();
        state.buttons = list.length;
        if (isIos) {
            // No install prompt on iOS: reveal the page buttons right away, or the
            // chip when the page has none (both show the steps on tap).
            list.forEach(bindIos);
            if (list.length) hideChip(); else if (iosHint) showChip();
            return;
        }
        if (!deferred) return;
        if (list.length) {
            // Buttons placed in the page take precedence over the floating chip.
            list.forEach(bindInstall);
            hideChip();
        } else {
            showChip();
        }
    }

    function hide() {
        hideChip();
        buttons().forEach(function (btn) { btn.setAttribute('hidden', ''); });
    }

    window.addEventListener('beforeinstallprompt', function (e) {
        e.preventDefault();
        deferred = e;
        state.installable = true;
        refresh();
    });
    window.addEventListener('appinstalled', function () {
        deferred = null;
        state.installable = false;
        remember();
        hide();
    });

    // Blazor renders the page after this script ran (and re-renders on navigation):
    // pick up buttons as they appear, one refresh per animation frame at most.
    var pending = false;
    function schedule() {
        if (pending) return;
        pending = true;
        (window.requestAnimationFrame || setTimeout)(function () { pending = false; refresh(); });
    }
    if (window.MutationObserver) {
        new MutationObserver(function (records) {
            for (var i = 0; i < records.length; i++) {
                var added = records[i].addedNodes;
                for (var j = 0; j < added.length; j++) {
                    var n = added[j];
                    if (n.nodeType === 1 && (n.matches(SELECTOR) || n.querySelector(SELECTOR))) { schedule(); return; }
                }
            }
        }).observe(document.documentElement, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
    else refresh();
})();
